import { ElementState } from "@creatomate/preview";

const removePrefix = (name: string, prefixes: string[]) => {
  const prefix = prefixes.find(p => name.startsWith(p));
  return prefix ? name.replace(prefix, "") : name;
};

const getTimelineElementName = (
  element: ElementState,
  isSmallElement: boolean
) => {
  if (isSmallElement) return "";

  const { source: { name, type } } = element;
  const prefixes = ["media-"];

  return removePrefix(name ?? type[0].toUpperCase() + type.slice(1), prefixes);
};

export default getTimelineElementName;
